import ChangePasswordPage from "../pages/auth/change";
import ForgotPasswordPage from "../pages/auth/forgot";
import LoginPage from "../pages/auth/login";
import LogoutPage from "../pages/auth/logout";
import RegisterPage from "../pages/auth/register";
import ResetPasswordPage from "../pages/auth/reset";
import HomePage from "../pages/Home";
import AppsPage from '../pages/Apps';

const routes = [
    {
        path: '/',
        exact: true,
        component: HomePage,
        name: 'Home Page'
    },
    {
        path: '/apps',
        exact: true,
        component: AppsPage,
        name: 'Applications'
    },
    {
        path: '/register',
        exact: true,
        component: RegisterPage,
        name: 'Register Page'
    },
    {
        path: '/login',
        exact: true,
        component: LoginPage,
        name: 'Login Page',
    },
    {
        path: '/change',
        exact: true,
        component: ChangePasswordPage,
        name: 'Change Password Page',
    },
    {
        path: '/logout',
        exact: true,
        component: LogoutPage,
        name: 'Logout Page',
    },
    {
        path: '/forget',
        exact: true,
        component: ForgotPasswordPage,
        name: 'Forgot Password Page',
    },
    {
        path: '/reset',
        exact: true,
        component: ResetPasswordPage,
        name: 'Reset Password Page',
    }
];

export default routes;
